import { jsx as _jsx } from "react/jsx-runtime";
import NotFound from "@components/common/error/NotFound";
import SystemError from "@components/common/error/SystemError";
import EhpPdfViewer from "@components/common/pdfviewer/EhpPdfViewer";
import ConsultingMain from "@components/dashBoard/consulting/ConsultingMain";
import OperationManagementMain from "@components/dashBoard/operationmanagement/OperationManagementMain";
import ProposalMain from "@components/dashBoard/proposal/ProposalMain";
import ReportMain from "@components/dashBoard/report/ReportMain";
import TodaysInspectionMain from "@components/dashBoard/todaysInspection/TodaysInspectionMain";
import Login from "@components/login/Login";
import HomeMain from "@components/main/home/HomeMain";
import CmmCertification from "@components/main/verifyEmail/community/CmmCertification";
import EhpCertification from "@components/main/verifyEmail/EhpCertification";
import ApprovalMain from "@components/management/approval/ApprovalMain";
import CheckSheetMain from "@components/management/checksheet/CheckSheetMain";
import CommunityManagementMain from "@components/management/community/CommunityManagementMain";
import DownloadMain from "@components/management/download/DownloadMain";
import EconsultMain from "@components/management/econsult/EconsultMain";
import EnergySolutionManagementMain from "@components/management/energySolution/EnergySolutionManagementMain";
import InformMain from "@components/management/inform/InformMain";
import MenuMain from "@components/management/menu/MenuMain";
import SiteMain from "@components/management/site/SiteMain";
import SolutionMaIn from "@components/management/solution/SolutionMaIn";
import SpgMain from "@components/management/spgs/SpgMain";
import UserMain from "@components/management/user/UserMain";
import { DashBoardLayout } from "@layout/DashBoardLayout";
import MainPortalLayout from "@layout/MainPortalLayout";
import ManagementLayout from "@layout/ManagementLayout";
import ServiceLayout from "@layout/ServiceLayout";
import PrivateRoute from "@router/PrivateRoute";
import PublicRoute from "@router/PublicRoute";
import "@static/css/style.css";
import * as CONST from "@utils/Const";
import { lazy, Suspense } from "react";
import { Navigate } from "react-router-dom";
const SuspenseLoader = () => {
    return (_jsx("div", Object.assign({ className: "loading", style: { overflowY: "hidden" } }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB85C\uB529\uC911" })) })));
};
const Loader = (Component) => (props) => (_jsx(Suspense, Object.assign({ fallback: _jsx(SuspenseLoader, {}) }, { children: _jsx(Component, Object.assign({}, props)) })));
//Main 포탈 화면
const WhatWeDo = Loader(lazy(() => import("@components/main/whatwedo/WhatWeDoMain")));
const MarketPlace = Loader(lazy(() => import("@components/main/market/MarketPlaceMain")));
const Contact = Loader(lazy(() => import("@components/main/contact/ContactMain")));
const Community = Loader(lazy(() => import("@components/main/community/CommunityMain")));
const DownloadPortal = Loader(lazy(() => import("@components/main/download/DownloadPortalMain")));
const Mypage = Loader(lazy(() => import("@components/main/mypage/MypageMain")));
//대시보드 화면
const Monitoring = Loader(lazy(() => import("@components/dashBoard/monitoring/MonitoringMain")));
const EnergySolution = Loader(lazy(() => import("@components/dashBoard/energysolution/EnergySolutionMain")));
//도움말 & 상담신청 화면
const Help = Loader(lazy(() => import("@components/serviceIntroduction/help/HelpMain")));
const Consultation = Loader(lazy(() => import("@components/serviceRequest/consultation/ConsultationApplication")));
const routes = [
    {
        element: _jsx(PublicRoute, { component: null }),
        children: [
            {
                path: CONST.URL_LOGIN,
                element: _jsx(Login, {}),
            },
            {
                path: CONST.URL_COMM_PDFVIEWER,
                element: _jsx(EhpPdfViewer, {}),
            },
            {
                path: CONST.URL_VERIFYEMAIL,
                element: _jsx(EhpCertification, {}),
            },
            {
                path: "/",
                element: _jsx(Navigate, { to: CONST.URL_MAIN, replace: true }),
            },
        ],
    },
    {
        element: _jsx(PublicRoute, { component: MainPortalLayout }),
        children: [
            {
                path: CONST.URL_MAIN,
                element: _jsx(HomeMain, {}),
            },
            {
                path: CONST.URL_WHATWEDO,
                element: _jsx(WhatWeDo, {}),
            },
            {
                path: CONST.URL_MARKETPLACE,
                element: _jsx(MarketPlace, {}),
            },
            {
                path: CONST.URL_CONTACTUS,
                element: _jsx(Contact, {}),
            },
            {
                path: CONST.URL_COMMUNITY,
                element: _jsx(Community, {}),
            },
            {
                path: CONST.URL_DOWNLOAD,
                element: _jsx(DownloadPortal, {}),
            },
            {
                path: CONST.URL_MYPAGE,
                element: _jsx(Mypage, {}),
            },
            {
                path: CONST.URL_VERIFYEMAILCOMMUNITY,
                element: _jsx(CmmCertification, {}),
            },
        ],
    },
    {
        element: _jsx(PrivateRoute, { component: DashBoardLayout }),
        children: [
            {
                path: CONST.URL_MONITORING,
                element: _jsx(Monitoring, {}),
            },
            {
                path: CONST.URL_TODAYINSPECTION,
                element: _jsx(TodaysInspectionMain, {}),
            },
            {
                path: CONST.URL_ENERGYSOLUTION,
                element: _jsx(EnergySolution, {}),
            },
            {
                path: CONST.URL_CONSULTION,
                element: _jsx(ConsultingMain, {}),
            },
            {
                path: CONST.URL_PROPOSAL,
                element: _jsx(ProposalMain, {}),
            },
            {
                path: CONST.URL_OPERATION,
                element: _jsx(OperationManagementMain, {}),
            },
            {
                path: CONST.URL_REPORT,
                element: _jsx(ReportMain, {}),
            },
        ],
    },
    {
        element: _jsx(PrivateRoute, { component: ManagementLayout }),
        children: [
            {
                path: CONST.URL_APPROVALMANAGEMENT,
                element: _jsx(ApprovalMain, {}),
            },
            {
                path: CONST.URL_USERMANAGEMENT,
                element: _jsx(UserMain, {}),
            },
            {
                path: CONST.URL_SITEMANAGEMENT,
                element: _jsx(SiteMain, {}),
            },
            {
                path: CONST.URL_MENUMANAGEMENT,
                element: _jsx(MenuMain, {}),
            },
            {
                path: CONST.URL_CHECKSHEETMANAGEMENT,
                element: _jsx(CheckSheetMain, {}),
            },
            {
                path: CONST.URL_ECONSULTMANAGEMENT,
                element: _jsx(EconsultMain, {}),
            },
            {
                path: CONST.URL_SPGMANAGEMENT,
                element: _jsx(SpgMain, {}),
            },
            {
                path: CONST.URL_SOLUTIONMANAMENT,
                element: _jsx(SolutionMaIn, {}),
            },
            {
                path: CONST.URL_COMMUNITYMANAGEMENT,
                element: _jsx(CommunityManagementMain, {}),
            },
            {
                path: CONST.URL_INFOMANAGEMENT,
                element: _jsx(InformMain, {}),
            },
            {
                path: CONST.URL_DOWNLOADMANAGEMENT,
                element: _jsx(DownloadMain, {}),
            },
            {
                path: CONST.URL_ENERGYSOLUTIONMANAGEMENT,
                element: _jsx(EnergySolutionManagementMain, {}),
            },
        ],
    },
    {
        element: _jsx(PrivateRoute, { component: ServiceLayout }),
        children: [
            {
                path: CONST.URL_HELP,
                element: _jsx(Help, {}),
            },
            {
                path: CONST.URL_INTRODUCTIONINQUIRY,
                element: _jsx(Consultation, {}),
            },
        ],
    },
    {
        path: "*",
        element: _jsx(Navigate, { to: CONST.URL_NOT_FOUND, replace: true }),
    },
    {
        element: _jsx(PublicRoute, { component: null }),
        children: [
            {
                path: CONST.URL_NOT_FOUND,
                element: _jsx(NotFound, {}),
            },
            {
                path: CONST.URL_SYSTEM_ERROR,
                element: _jsx(SystemError, {}),
            },
        ],
    },
];
export default routes;
